// extracted by mini-css-extract-plugin
export var copy = "error-module--copy--96b1a";
export var copyWithImage = "error-module--copy-with-image--4c7e5";
export var grid = "error-module--grid--ffb91";
export var gridNoImage = "error-module--grid-no-image--cd07a";
export var headingImage = "error-module--heading-image--c537c";
export var image = "error-module--image--d15d0";